var _defs, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieceskids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12.91 7.53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        font-family: ZaraH1Sans-Bold, 'Zara H1 Sans';\n        font-weight: 700;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #1d1d1b;\n        font-size: 3.38px;\n      }\n\n      .cls-3 {\n        letter-spacing: .07em;\n      }\n\n      .cls-4 {\n        letter-spacing: .08em;\n      }\n\n      .cls-5 {\n        letter-spacing: .12em;\n      }\n\n      .cls-6 {\n        letter-spacing: .09em;\n      }\n\n      .cls-7 {\n        letter-spacing: .09em;\n      }\n\n      .cls-2 {\n        font-family: ZaraH1Sans-Medium, 'Zara H1 Sans';\n        font-weight: 500;\n      }\n\n      .cls-8 {\n        letter-spacing: .12em;\n      }\n\n      .cls-9 {\n        letter-spacing: .12em;\n      }\n\n      .cls-10 {\n        letter-spacing: .1em;\n      }\n\n      .cls-11 {\n        letter-spacing: .12em;\n      }"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 2.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 2.39,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 3.72,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 5.97,
    y: 0
  }, "Z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 8.36,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.06,
    y: 0
  }, "S"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 6.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 0,
    y: 0
  }, "PI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 3.85,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 6.21,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 8.67,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.06,
    y: 0
  }, "S"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieceskids);
export default __webpack_public_path__ + "static/media/pieceskids.e183011e2840e014f3cbfeab4816da7a.svg";
export { ForwardRef as ReactComponent };